import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { Member } from "@/app/(main)/(club)/mes-clubs/[id]/components/edit-event-modal-content";
export const useAvailableMembers = (attendedMembers, absentMembers) => {
  const $ = _c(3);
  let t0;
  if ($[0] !== absentMembers || $[1] !== attendedMembers) {
    t0 = attendedMembers?.filter(member => !absentMembers?.find(m => m["@id"] === member["@id"])).map(_temp);
    $[0] = absentMembers;
    $[1] = attendedMembers;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
function _temp(member_0) {
  return <option key={member_0["@id"]} value={member_0["@id"]}>{member_0.firstName} {member_0.lastName}</option>;
}